import Swiper from 'swiper'

export default () => ({
    swiper: null,

    init() {
        this.$nextTick(() => {

            this.swiper = new Swiper(this.$refs.slider, {
                spaceBetween: 24,
                watchOverflow: true,

                breakpoints: {

                    // 360–700 примерно
                    0: {
                        slidesPerView: 1.5,
                        allowTouchMove: true,
                    },

                    // 700–1024 (делаем 3 статично)
                    768: {
                        slidesPerView: 3,
                        allowTouchMove: false,
                    },

                    // 1024–1350 проблемная зона
                    1024: {
                        slidesPerView: 1.5,
                        allowTouchMove: true,
                    },

                    // >1280 / >1350 нормальный диапазон
                    1280: {
                        slidesPerView: 3,
                        allowTouchMove: false,
                    },
                },
            })

        })
    },

    prev() {
        this.swiper?.slidePrev()
    },

    next() {
        this.swiper?.slideNext()
    },
})
